export enum Workflow {
	DrugTest = 100,
	ParticipantEligibility = 300,
	Phase = 400,
	CaseClosure = 500,
}